import merge from 'lodash/merge';
import { ModelWatchServiceModule } from './modelWatch.service';
import { ModelParseServiceModule } from './modelParse.service';

export const ModelServiceModule = angular
    .module('app.services.data.modelService.modelService', [
        ModelWatchServiceModule,
        ModelParseServiceModule
    ]).service('modelService', ($window, modelParser, modelWatcher) => {
        var api = {
            makeModel: makeModel,
            makeEmptyModel: makeEmptyModel
        };

        function makeModel(obj, model) {
            var newObj = {};
            if (model) {
                newObj = modelParser.parse(model);
                obj = merge(newObj, obj);
            }

            return new Model(obj);
        }

        function makeEmptyModel(model) {
            var keys = {};

            if (model) {
                keys = modelParser.parse(model);
            }

            return new Model(keys);
        }

        function Model(model) {
            Object.defineProperties(this, {
                _base: {
                    enumerable: false,
                    value: angular.copy(model)
                },
                model: {
                    enumerable: false,
                    value: model,
                    writable: true
                },
                changedValues: {
                    enumerable: false,
                    value: [],
                    writable: true
                },
                _stash: {
                    enumerable: false,
                    value: {},
                    writable: true
                }
            });

            modelWatcher.assignWatchers(this);
        }

        Object.defineProperties(Model.prototype, {
            getChanges: {
                enumerable: false,
                value: modelWatcher.getChanges
            },
            hasChanges: {
                enumerable: false,
                value: modelWatcher.hasChanges
            },
            reset: {
                enumerable: false,
                value: modelWatcher.reset
            },
            update: {
                enumerable: false,
                value: modelWatcher.update
            },
            updateChanges: {
                enumerable: false,
                value: modelWatcher.updateChangedValues
            },
            stash: {
                enumerable: false,
                value: modelWatcher.stash
            },
            unstash: {
                enumerable: false,
                value: modelWatcher.unstash
            },
            makeDirty: {
                enumerable: false,
                value: modelWatcher.makeDirty
            }
        });

        $window.Model = Model;

        return api;
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/model.service.js